var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"color":"green","dark":"","scroll-target":"#scrolling-techniques-2"}},[_c('p',[_vm._v("Primal Algorithm (便利ツール置き場)")])]),_c('v-main',[_c('HelloWorld')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }